var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"padless":"","color":'#f57c00',"absolute":"","app":""}},[_c('v-col',{staticClass:"white--text text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.$t('COPYRIGHT', { year: new Date().getFullYear() }))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }